import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import apiUrl from "../../Environment/Api";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/img/Admin/edffsd.png";

function Projectreport() {
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const [exchangeRate, setExchangeRate] = useState(85);
  const [columnConfigs, setColumnConfigs] = useState({});
  const [csvData, setCsvData] = useState([]);
  const [selectedEditor, setSelectedEditor] = useState("");

  const UserRole = localStorage.getItem("role");
  const UserId = localStorage.getItem("editor_id");

  console.log("User Role", UserRole);

  // Base columns that are ALWAYS shown
  const baseColumns = [
    "standard",
    "premier",
    "twilight",
    "day_to_dusk",
    "vra",
    "vr",
  ];

  // Extra columns (col7-col12) will be shown ONLY if they contain actual data
  const possibleExtraColumns = [
    "col7",
    "col8",
    "col9",
    "col10",
    "col11",
    "col12",
  ];

  const [displayColumns, setDisplayColumns] = useState(baseColumns);

  // Dynamic columns: show col7-col12 only when they have data somewhere
  useEffect(() => {
    if (originalData.length === 0) {
      setDisplayColumns(baseColumns);
      return;
    }

    const extraWithData = possibleExtraColumns.filter((col) =>
      originalData.some((row) => {
        const val = row[col];
        return val != null && val !== "" && val !== "0" && val !== 0;
      }),
    );

    setDisplayColumns([...baseColumns, ...extraWithData]);
  }, [originalData]);

  // Group data by client
  const groupDataByClient = (data) => {
    const grouped = {};
    data.forEach((item) => {
      const clientKey = item.clientId;
      if (!grouped[clientKey]) {
        grouped[clientKey] = {
          clientId: item.clientId,
          clientName: item.clientName,
          invoiceId: item.invoiceId,
          editors: [],
          totalPrice: 0,
          totalTax: 0,
          totalAmount: 0,
          rowSpan: 0,
        };
      }
      grouped[clientKey].editors.push(item);
      grouped[clientKey].totalPrice += parseFloat(item.price) || 0;
      grouped[clientKey].totalTax += parseFloat(item.tax) || 0;
      grouped[clientKey].totalAmount += parseFloat(item.totalAmount) || 0;
      grouped[clientKey].rowSpan++;
    });
    return Object.values(grouped);
  };

  // Fetch column configurations for all invoices
  const fetchAllColumnConfigs = async (invoiceIds) => {
    const configs = {};
    for (const invoiceId of invoiceIds) {
      try {
        const response = await axios.get(
          apiUrl + `/invoice-columns/${invoiceId}`,
        );
        console.log(`Column config for ${invoiceId}:`, response.data);
        if (
          response.data &&
          response.data.status === "success" &&
          response.data.data
        ) {
          configs[invoiceId] = response.data.data;
        }
      } catch (error) {
        console.log(`Error fetching column config for ${invoiceId}:`, error);
      }
    }
    setColumnConfigs(configs);
    console.log("All column configs loaded:", configs);
  };

  const getdata = async () => {
    try {
      const response = await axios.get(apiUrl + "/invoicelist");
      const rawInvoices = response.data || [];

      // Get unique invoiceIds for column config fetching
      const uniqueInvoiceIds = [
        ...new Set(rawInvoices.map((item) => item.invoiceId)),
      ];
      fetchAllColumnConfigs(uniqueInvoiceIds);

      // Flatten the nested structure: one row per editor entry + client info
      let flatData = rawInvoices.flatMap((invoice) =>
        invoice.editors.map((editor, index) => ({
          ...editor,
          client_id: invoice.client_id,
          client_name: invoice.client_name,
          clientId: invoice.client_id,
          clientName: invoice.client_name,
          invoiceId: invoice.invoiceId,
          isFirstRow: index === 0, // Mark first row of each client
        })),
      );

      // Filter only for editor
      if (UserRole === "editor") {
        flatData = flatData.filter(
          (item) =>
            item.editor_id?.toString().trim().toLowerCase() ===
            UserId?.toString().trim().toLowerCase(),
        );
      }

      console.log("UserId:", UserId);
      console.log("Flat Data:", flatData);

      setOriginalData(flatData);
      const grouped = groupDataByClient(flatData);
      setGroupedData(grouped);
      setFilteredData(flatData);
      prepareCSVData();
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const [getclientdetails, setclientdetails] = useState([]);
  const clientdetails = async () => {
    try {
      const response = await axios.get(apiUrl + "/clientdetails");
      setclientdetails(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const [getEditor, setEditor] = useState([]);
  const editorDetails = async () => {
    try {
      const response = await axios.get(`${apiUrl}/editor`);
      setEditor(response.data || []);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    editorDetails();
    clientdetails();
    getdata();
  }, []);

  // Get column name from database for specific invoice
  const getColumnName = (invoiceId, columnKey) => {
    const config = columnConfigs[invoiceId];
    if (config && config[columnKey] && config[columnKey].trim() !== "") {
      return config[columnKey];
    }
    // Fallback to default names
    const defaultNames = {
      standard: "Standard",
      premier: "Premier",
      twilight: "Twilight",
      day_to_dusk: "Day to Dusk",
      vra: "VRA",
      vr: "VR",
      col7: "Col7",
      col8: "Col8",
      col9: "Col9",
      col10: "Col10",
      col11: "Col11",
      col12: "Col12",
    };
    return defaultNames[columnKey] || columnKey;
  };

  // Format as "ColumnName-Value"
  const formatColumnDisplay = (invoiceId, columnKey, value) => {
    if (!value || value === "" || value === "0" || value === 0) {
      return "";
    }
    const columnName = getColumnName(invoiceId, columnKey);
    return `${value}`;
  };

  const handlesearchFilter = (e) => {
    e.preventDefault();
    const inputValue = e.target.value.trim().toLowerCase();
    const filteredData = originalData.filter((data) =>
      Object.values(data).some((value) =>
        value.toString().toLowerCase().includes(inputValue),
      ),
    );
    setFilteredData(filteredData);
    const grouped = groupDataByClient(filteredData);
    setGroupedData(grouped);
    prepareCSVData();
  };

  useEffect(() => {
    const fetchExchangeRate = async () => {
      try {
        const response = await fetch(
          "https://api.frankfurter.app/latest?from=USD&to=INR",
        );
        const data = await response.json();
        setExchangeRate(data.rates.INR);
      } catch (error) {
        console.error("Error fetching exchange rate:", error);
        setExchangeRate(85);
      }
    };
    fetchExchangeRate();
  }, []);

  useEffect(() => {
    if (groupedData.length > 0) {
      prepareCSVData();
    }
  }, [groupedData, displayColumns, exchangeRate, getclientdetails]);

  // CSV page
  const prepareCSVData = () => {
    const csvDataArray = [];
    let serialNo = 1;

    groupedData.forEach((client) => {
      client.editors.forEach((editor, editorIndex) => {
        const row = {};
        row["S No."] = serialNo;
        // row["Client Name"] = editorIndex === 0 ? client.clientName : "";

        const clientData = getclientdetails.find(
          (c) => c.client_id === client.clientId,
        );

        row["Client Name"] =
          editorIndex === 0
            ? UserRole === "editor"
              ? clientData?.alternat_name || client.clientName
              : client.clientName
            : "";
        row["Date"] = formatDate(editor.date);
        row["Address"] = editor.projectName;

        // Add only the visible columns
        displayColumns.forEach((col) => {
          const columnName = getColumnName(editor.invoiceId, col);
          row[columnName] = editor[col] || "";
        });

        if (UserRole !== "editor") {
          row["Price"] =
            editorIndex === client.editors.length - 1
              ? client.totalPrice.toFixed(2)
              : "";

          row["Tax(%)"] =
            editorIndex === client.editors.length - 1
              ? client.totalTax.toFixed(2)
              : "";

          const clientData = getclientdetails.find(
            (c) => c.client_id === client.clientId,
          );

          // const clientData = getclientdetails.find(
          //   (c) => c.id === client.clientId,
          // );

          if (clientData) {
            const isIndian = clientData.countrycode === "91";
            const currencySymbol = isIndian ? "₹" : "$";

            const displayAmount = client.totalAmount;

            row["Total Amount"] =
              editorIndex === client.editors.length - 1
                ? `${currencySymbol} ${displayAmount.toFixed(2)}`
                : "";
          }
        }

        csvDataArray.push(row);
      });
      serialNo++;
    });

    setCsvData(csvDataArray);
    return csvDataArray;
  };

  // Pdf page
  const generatePDF = () => {
    const pdf = new jsPDF("l", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();

    // Logo
    const logoImage = new Image();
    logoImage.src = logo;
    pdf.addImage(logoImage, "PNG", 15, 5, 25, 25);

    // Title (CENTER)
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text("Project Reports", pageWidth / 2, 15, { align: "center" });

    // Company Details (RIGHT SIDE)
    pdf.setFontSize(8);
    pdf.setFont("helvetica", "normal");
    pdf.text("VAS Post Production", pageWidth - 15, 10, { align: "right" });
    pdf.text("Vasanthan. K", pageWidth - 15, 14, { align: "right" });
    pdf.text(
      "87, Kamarajar Nagar,\nDadagapatti,\nSalem-6",
      pageWidth - 15,
      18,
      { align: "right" },
    );

    // Table
    pdf.autoTable({
      html: tableRef.current,
      startY: 35,
      styles: {
        fontSize: 8,
      },
      headStyles: {
        fillColor: [41, 128, 185],
        halign: "center",
      },
      bodyStyles: {
        halign: "left",
      },
    });

    pdf.save("Project_Reports.pdf");
  };

  // Excel page
  const generateExcel = () => {
    const dataForExcel = [];
    let serialNo = 1;

    groupedData.forEach((client) => {
      client.editors.forEach((editor, editorIndex) => {
        const clientData = getclientdetails.find(
          (c) => c.client_id === client.clientId,
        );

        const row = {
          "S No.": serialNo,
          //   "Client Name": editorIndex === 0 ? client.clientName : "",

          "Client Name":
            editorIndex === 0
              ? UserRole === "editor"
                ? clientData?.alternat_name || client.clientName
                : client.clientName
              : "",
          Date: formatDate(editor.date),
          Address: editor.projectName,
        };

        // Add only the visible columns
        displayColumns.forEach((col) => {
          const columnName = getColumnName(editor.invoiceId, col);
          const displayValue = formatColumnDisplay(
            editor.invoiceId,
            col,
            editor[col],
          );
          row[columnName] = displayValue || editor[col] || "";
        });

        if (UserRole !== "editor") {
          row["Price"] =
            editorIndex === client.editors.length - 1
              ? client.totalPrice.toFixed(2)
              : "";

          row["Tax(%)"] =
            editorIndex === client.editors.length - 1
              ? client.totalTax.toFixed(2)
              : "";

          const clientData = getclientdetails.find(
            (c) => c.client_id === client.clientId,
          );

          // const clientData = getclientdetails.find(
          //   (c) => c.id === client.clientId,
          // );

          if (clientData) {
            const isIndian = clientData.countrycode === "91";
            const currencySymbol = isIndian ? "₹" : "$";

            const displayAmount = client.totalAmount;

            row["Total Amount"] =
              editorIndex === client.editors.length - 1
                ? `${currencySymbol} ${displayAmount.toFixed(2)}`
                : "";
          }
        }

        dataForExcel.push(row);
      });
      serialNo++;
    });

    const ws = XLSX.utils.json_to_sheet(dataForExcel);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Reports");
    XLSX.writeFile(wb, "Reports.xlsx");
  };

  // print page
  const handletoprint = () => {
    navigate("/reportprint");
  };

  const [selectedproject, setSelectedproject] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const handleFilterClick = (e) => {
    e.preventDefault();
    let newData = originalData.slice();

    // Filter by Client
    if (selectedproject) {
      newData = newData.filter(
        (data) => String(data.client_id) === selectedproject,
      );
    }

    // Filter by Editor
    if (selectedEditor) {
      newData = newData.filter(
        (data) => String(data.editor_id) === selectedEditor,
      );
    }

    // Filter by Date
    if (fromDate && toDate) {
      newData = newData.filter((data) => {
        const dataDate = new Date(data.date);
        const fromDateTime = new Date(fromDate);
        const toDateTime = new Date(toDate);
        return dataDate >= fromDateTime && dataDate <= toDateTime;
      });
    }
    setFilteredData(newData);
    const grouped = groupDataByClient(newData);
    setGroupedData(grouped);
  };

  const clearFilters = (e) => {
    e.preventDefault();
    setSelectedproject("");
    setSelectedEditor("");
    setFromDate("");
    setToDate("");
    setFilteredData(originalData);
    const grouped = groupDataByClient(originalData);
    setGroupedData(grouped);
  };

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Prepare paginated grouped data for display
  const getPaginatedDisplayData = () => {
    const allRows = [];
    let globalSerialNo = 1;

    groupedData.forEach((client) => {
      client.editors.forEach((editor, editorIndex) => {
        allRows.push({
          client,
          editor,
          editorIndex,
          isFirstRow: editorIndex === 0,
          isLastRow: editorIndex === client.editors.length - 1,
          serialNo: globalSerialNo,
        });
      });
      globalSerialNo++;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return allRows.slice(indexOfFirstItem, indexOfLastItem);
  };

  const paginatedDisplayData = getPaginatedDisplayData();
  const totalPages = Math.ceil(
    groupedData.reduce((sum, client) => sum + client.editors.length, 0) /
      itemsPerPage,
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleItemsPerPageChange = (e) => {
    setCurrentPage(1);
    setItemsPerPage(Number(e.target.value));
  };

  const printTable = () => {
    const printWindow = window.open("", "_blank");

    const tableContainer = document.getElementById("table-container");

    printWindow.document.write(`
    <html>
    <head>
      <title>Project Reports</title>
      <style>
        body {
          font-family: Arial;
          padding: 20px;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .title {
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          margin-top: 10px;
        }

        .company {
          text-align: right;
          font-size: 12px;
        }

        img {
          width: 80px;
        }

        table {
          border-collapse: collapse;
          width: 100%;
          margin-top: 20px;
        }

        table, th, td {
          border: 1px solid black;
        }

        th {
          background-color: #2980b9;
          color: white;
        }

        th, td {
          padding: 8px;
          text-align: left;
          font-size: 12px;
        }
      </style>
    </head>

    <body>
      <div class="header">
        <img src="${logo}" />
        <div class="company">
          <div>VAS Post Production</div>
          <div>Vasanthan. K</div>
          <div>87, Kamarajar Nagar,<br/>Dadagapatti,<br/>Salem-6</div>
        </div>
      </div>

      <div class="title">Project Reports</div>

      ${tableContainer ? tableContainer.innerHTML : ""}

    </body>
    </html>
  `);

    printWindow.document.close();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === "Invalid Date") {
      return "";
    }
    const date = new Date(dateString);
    const formattedDate = date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
    return formattedDate;
  };

  // Get client totals for display
  const getClientTotals = (clientId) => {
    const client = groupedData.find((c) => c.clientId === clientId);
    return client || { totalPrice: 0, totalTax: 0, totalAmount: 0 };
  };

  return (
    <>
      <div>
        <div className="card cardshadow">
          <div className="p-4">
            <h5 className="fw-bold">Project Reports</h5>
            <hr className="mt-3" />
          </div>
          <div>
            <form className="d-flex pt-0 p-3">
              <div className="mx-3 dropdown">
                <label className="form-label">Client Name</label>
                <div className="position-relative">
                  <select
                    className="form-control dropdown-toggle custom-select"
                    value={selectedproject}
                    onChange={(e) => setSelectedproject(e.target.value)}
                  >
                    <option value="">All Clients</option>
                    {getclientdetails.map((data, id) => (
                      <option key={id} value={data.client_id}>
                        {data.client_id} -{" "}
                        {UserRole === "editor"
                          ? data.alternat_name
                          : data.clientName}
                      </option>
                    ))}
                  </select>
                  <div className="dropdown-arrow"></div>
                </div>
              </div>

              {UserRole !== "editor" && (
                <div className="mx-3 dropdown">
                  <label className="form-label">Editor Name</label>
                  <div className="position-relative">
                    <select
                      className="form-control dropdown-toggle custom-select"
                      value={selectedEditor}
                      onChange={(e) => setSelectedEditor(e.target.value)}
                    >
                      <option value="">All Editors</option>
                      {getEditor.map((data, id) => (
                        <option key={id} value={data.editor_id}>
                          {data.editor_id} - {data.editorName}
                        </option>
                      ))}
                    </select>
                    <div className="dropdown-arrow"></div>
                  </div>
                </div>
              )}

              <div className="mx-3">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>
              <div className="mx-3">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              <div className="mx-3">
                <button
                  onClick={handleFilterClick}
                  className="btn btn-primary filterbutton"
                >
                  <i className="fa-solid fa-filter"></i>
                </button>
                <button
                  onClick={clearFilters}
                  className="btn btn-secondary clearbutton mx-2"
                >
                  clear
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="d-flex justify-content-between mb-2">
          <form className="seach-content">
            <label className="form-label mb-1">Show per page:</label>
            <select
              className="form-select"
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={500}>500</option>
            </select>
          </form>
          <div className="button-save" style={{ height: "20px" }}>
            <CSVLink data={csvData} filename={"Reports.csv"}>
              <button className="btn btn btn-secondary mx-1">CSV</button>
            </CSVLink>
            <button
              className="btn btn btn-success mx-1"
              onClick={generateExcel}
            >
              Excel
            </button>
            <button className="btn btn btn-danger mx-1" onClick={generatePDF}>
              PDF
            </button>
            <button className="btn btn btn-warning mx-1" onClick={printTable}>
              Print
            </button>
          </div>
          <form className="seach-content">
            <label className="form-label mb-1">Search :</label>
            <input
              className="form-control"
              type="text"
              onChange={handlesearchFilter}
            ></input>
          </form>
        </div>
        <div id="table-container" className="table-responsive">
          <table ref={tableRef} className="table table-striped">
            <thead>
              <tr className="table-primary">
                <th>S.no</th>
                <th>Client Id / Name</th>
                <th>Editor Id / Name</th>
                <th>Date</th>
                <th>Address</th>
                {displayColumns.map((columnKey) => (
                  <th key={columnKey}>
                    {groupedData.length > 0 && groupedData[0].editors.length > 0
                      ? getColumnName(
                          groupedData[0].editors[0].invoiceId,
                          columnKey,
                        )
                      : columnKey}
                  </th>
                ))}
                {UserRole !== "editor" && <th>Rate</th>}
                {UserRole !== "editor" && <th>Price</th>}
                {UserRole !== "editor" && <th>Tax</th>}
                {UserRole !== "editor" && <th>Total Amount</th>}
              </tr>
            </thead>
            <tbody>
              {paginatedDisplayData.length > 0 ? (
                paginatedDisplayData.map((item, displayIndex) => {
                  const {
                    client,
                    editor,
                    editorIndex,
                    isFirstRow,
                    isLastRow,
                    serialNo,
                  } = item;
                  const clientTotals = getClientTotals(client.clientId);

                  return (
                    <tr key={`${client.clientId}-${editorIndex}`}>
                      <td>{serialNo}</td>
                      <td>
                        {isFirstRow &&
                          (() => {
                            const clientData = getclientdetails.find(
                              (c) => c.client_id === client.clientId,
                            );

                            // Editor → Alternate Name
                            if (UserRole === "editor") {
                              return `${client.clientId} - ${
                                clientData?.alternat_name || client.clientName
                              }`;
                            }

                            // Admin → ID + Name
                            return `${client.clientId} - ${client.clientName || ""}`;
                          })()}
                      </td>
                      <td>{`${editor.editor_id} - ${editor.editor_name}`}</td>
                      <td>{formatDate(editor.date)}</td>
                      <td>{editor?.projectName}</td>
                      {displayColumns.map((columnKey) => (
                        <td key={columnKey}>
                          {formatColumnDisplay(
                            editor.invoiceId,
                            columnKey,
                            editor[columnKey],
                          )}
                        </td>
                      ))}
                      {UserRole !== "editor" && (
                        <>
                          <td>{Number(editor?.rate || 0).toFixed(2)}</td>
                          <td>
                            {isLastRow
                              ? clientTotals.totalPrice.toFixed(2)
                              : ""}
                          </td>
                          <td>
                            {isLastRow ? `${clientTotals.totalTax} %` : ""}
                          </td>
                          <td>
                            {isLastRow &&
                              (() => {
                                const clientData = getclientdetails.find(
                                  (clientDetail) =>
                                    clientDetail.id === client.clientId,
                                );
                                if (clientData) {
                                  const isIndian =
                                    clientData.countrycode === "91";
                                  const currencySymbol = isIndian ? "₹" : "$";
                                  const displayAmount = isIndian
                                    ? clientTotals.totalAmount * exchangeRate
                                    : clientTotals.totalAmount;
                                  return `${currencySymbol} ${displayAmount.toFixed(2)}`;
                                }
                                return Math.round(
                                  clientTotals.totalAmount,
                                ).toFixed(2);
                              })()}
                          </td>
                        </>
                      )}

                      {/* {UserRole !== "editor" && (
                      <>
                        <td>
                          {isLastRow ? clientTotals.totalPrice.toFixed(2) : ""}
                        </td>

                        <td>
                          {isLastRow ? clientTotals.totalTax.toFixed(2) : ""}
                        </td>

                        <td>
                          {isLastRow &&
                            (() => {
                              const clientData = getclientdetails.find(
                                (c) => c.client_id === client.clientId, // ✅ FIXED
                              );

                              if (clientData) {
                                const isIndian =
                                  clientData.countrycode === "91";
                                const currencySymbol = isIndian ? "₹" : "$";

                                const displayAmount = isIndian
                                  ? clientTotals.totalAmount * exchangeRate
                                  : clientTotals.totalAmount;

                                return `${currencySymbol} ${displayAmount.toFixed(2)}`;
                              }

                              return clientTotals.totalAmount.toFixed(2);
                            })()}
                        </td>
                      </>
                    )} */}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={displayColumns.length + 6}
                    style={{ textAlign: "center" }}
                    className="py-3"
                  >
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div>
          <nav className="d-flex justify-content-end mx-2 pt-4">
            <ul className="pagination">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link mx-3"
                  onClick={() => paginate(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => paginate(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
              >
                <button
                  className="page-link mx-3"
                  onClick={() => paginate(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}

export default Projectreport;
